export class MicroappUserTenantFilter{
    general: string;
    host: string;
}